import { Map } from 'immutable'
import * as actions from './actions'

const listsReducer = (state = Map(), action) => {
  switch (action.type) {
    case actions.LISTS_RESET_LIST: {
      const { path } = action.payload
      return state.deleteIn(path)
    }

    case actions.LISTS_RESET_FILTERS: {
      const { path } = action.payload
      return state.deleteIn(path)
    }

    case actions.LISTS_SET_FILTER: {
      const { path, value } = action.payload
      return state.setIn(path, value)
    }

    case actions.LISTS_SET_PAGE: {
      const { path, value } = action.payload
      return state.setIn(path, value)
    }

    case actions.LISTS_SET_PAGE_LIMIT: {
      const { path, value } = action.payload
      return state.setIn(path, value)
    }

    case actions.LISTS_SET_SORT: {
      const { path } = action.payload
      let value = action.payload.value
      const currentValue = state.getIn(path)
      const reverseValue = `-${currentValue}`
      if (currentValue === value) value = reverseValue
      return state.setIn(path, value)
    }

    default:
      return state
  }
}

export default listsReducer



// WEBPACK FOOTER //
// ./src/common/lib/redux-lists/reducer.js